module.exports = __webpack_public_path__ + "static/fonts/iconfont.9ce54c13.ttf";